export const TOOLTIP_HOVER_DELAY = 500;

//# sourceMappingURL=constants.js.map